import React from 'react';
import { Link } from 'react-router-dom';

const Error404 = () => (
  <div className="row">
    <div className="col-md-12 center">
      <p>Sorry, the requested page does not exist.</p>
      <Link to="/">Back home</Link>
    </div>
  </div>
);

export default Error404;
